import React from 'react';

import Bold from '@components/elements/Bold';
import MethodsSectionTitle from '@components/experiments/methods/MethodsSectionTitle';
import ProseList from '@components/ProseList';

import { PeakAnalysis } from '@models/analysis/PeakAnalysis';
import Experiment from '@models/Experiment';
import Plot from '@models/Plot';

import { isDefined } from '@util/TypeGuards';

type Props = { plot: Plot; experiment: Experiment };
const PeakAnalysisMethodsSection = ({ plot, experiment }: Props) => {
    const analysis = plot.analysis as PeakAnalysis;
    const bigWigsUploaded = experiment.bigwigs_uploaded ?? false;

    const hasNoGroups = !isDefined(analysis.groups) || analysis.groups.length === 0;
    const groupNames: string[] = hasNoGroups ? ['all samples'] : analysis.groups.map((group) => group.display_name);

    const $groups = hasNoGroups ? (
        <Bold>all samples</Bold>
    ) : (
        <span>
            samples from the {`${analysis?.groups?.length === 1 ? 'group' : 'groups'}`}:{' '}
            <ProseList items={groupNames} />
        </span>
    );

    return (
        <section>
            <MethodsSectionTitle>Peak analysis</MethodsSectionTitle>

            <div className="space-y-4">
                {bigWigsUploaded ? (
                    <p>
                        Peaks were analyzed using bigWig files for {$groups}. User-provided bigWig files were normalized
                        using <Bold>{experiment.user_pipeline_params?.normalization_method}</Bold> prior to upload.
                    </p>
                ) : (
                    <p>
                        Peaks were analyzed using normalized bigWig files for {$groups}. Normalized bigWig files were
                        normalized to 1 million mapped reads.
                    </p>
                )}
            </div>
        </section>
    );
};

export default PeakAnalysisMethodsSection;
